var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:['cxm-IconLegacy', _vm.classes],attrs:{"type":"button","disabled":_vm.disable},on:{"click":function($event){$event.preventDefault();return _vm.iconClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('i',{class:_vm.iconSrc,style:({ 'font-size': _vm.size, color: _vm.color })})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }